<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- <br /> -->
    <v-row dense justify="center">
      <v-col cols="12" sm="5" md="3">
        <span v-for="header in headers" :key="header.text">
          <span v-if="filters.hasOwnProperty(header.value)">
            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined color="#0F2027"
              :label="header.text" multiple clearable :items="columnValueList(header.value)"
              v-model="filters[header.value]"></v-autocomplete>
          </span>
        </span>
      </v-col>
      <v-col cols="12" sm="1" md="1"></v-col>
      <v-col cols="12" sm="5" md="4">
        <v-text-field v-model="search" append-icon="search" label="Search" single-line
          placeholder="Search by Title / Decription / Date" clearable></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6" md="6" v-for="notice in searchByTitleOrDescription" :key="notice.id">
        <v-card dense class="box" :elevation="2" height="100%" @current-items="getFiltered">
          <v-chip class="ma-2" :color="!notice.visited ? 'warning' : 'info'">
            {{ notice.issue_date }}
          </v-chip>
          <v-card-title class="title font-weight-regular">
            {{ notice.title }}
          </v-card-title>
          <v-card-title class="body-2 font-weight-regular">
            Description:{{ notice.description }}
          </v-card-title>
          <template>
            <v-card-title class="title font-weight-regular" v-if="notice.webinar_link != null">
              <!-- {{ notice.webinar_link }} -->
              <a class="p-2" :href="notice.webinar_link" target="blank">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-if="notice.webinar_link" v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-eye</v-icon></v-btn>
                  </template>
                  <span> Visit Link !!! </span>
                </v-tooltip>
              </a>
            </v-card-title>
            <v-row v-if="notice.attachment && notice.visited">
              <v-col>
                <v-container fluid>
                  <v-row>
                    <v-col v-for="filepath in notice.attachment_links" :key="filepath.name" class="d-flex child-flex"
                      cols="6" sm="4" md="2">
                      <v-card flat tile v-if="!filepath.name.includes('mp4')">
                        <a class="p-2" :href="s3url + filepath.path + filepath.name" target="blank">
                          <v-img :src="`${s3url + filepath.path + filepath.name}`" :lazy-src="`${
                              s3url + filepath.path + filepath.name
                            }`" aspect-ratio="1" class="grey lighten-2">
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </a>
                      </v-card>
                      <v-card flat tile class="d-flex" v-else>
                        <video width="200" controls :src="`${s3url + filepath.path + filepath.name}`"></video>

                        <!-- <v-img
                          :src="
                            `${s3url+filepath.path+filepath.name}`
                          "
                          :lazy-src="
                            `${s3url+filepath.path+filepath.name}`
                          "
                          aspect-ratio="1"
                          class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img> -->
                      </v-card>
                    </v-col>
                  </v-row>
                  <br />

                  <!-- <div style="text-align: center">
            ----------------------------------Videos------------------------------------
                            </div> -->

                  <!-- <v-row>
                    <v-col
                      v-for="filepath in notice.attachment_video_links"
                      :key="filepath.name"
                      class="d-flex child-flex"
                      cols="3"
                    >
                      <v-card flat tile class="d-flex">
                        <video width="200" controls :src="
                            `${s3url+filepath.path}`
                          "></video>
                         <v-img
                          :src="
                            `${s3url+filepath.path}`
                          "
                          :lazy-src="
                            `${s3url+filepath.path+filepath.name}`
                          "
                          aspect-ratio="1"
                          class="grey lighten-2"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img> 
                      </v-card>
                    </v-col>
                  </v-row> -->
                </v-container>
              </v-col>
            </v-row>
          </template>
          <v-card-actions>
            <v-btn class="ma-2" small outlined color="indigo" v-if="!notice.visited && notice.attachment"
              @click="viewMoreAlbum(notice)">View Album</v-btn>
            <v-spacer> </v-spacer><v-card-subtitle> from @{{ notice.from }}</v-card-subtitle>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!--{{ child_notice }}-->
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    child_info: null,
    children: [],
    selected_children: "",
    child_notice: null,
    snackbar_msg: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    loader: true,
    search: "",
    s3url: "",
    headers: [{ text: "Academic Year", value: "academicyear" }],
    filters: {
      academicyear: [],
    },
  }),

  methods: {
    columnValueList(val) {
      return this.child_notice.notices.map((d) => d[val]);
    },
    getFiltered(e) {
      this.filterArr = e;
    },
    viewMoreAlbum(notice) {
      const formData = {
        id: notice.comm_parent_id,
        type: "Notice",
      };
      axios
        .post("/parent/noticeOrAlbumViewedByParent", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              // this.child_info = res.data.child_info;
              // this.childrenList();
              notice.visited = true;
            } else {
              alert(res.data.status_reason);
            }
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
    downloadNoticeAttachment(dlinkpath) {
      //console.log("dlinkpath>>"+dlinkpath)
      for (let j = 0; j < dlinkpath.length; j++) {
        var link = document.createElement("a");
        let path = dlinkpath[j].path;
        link.download = dlinkpath[j].name; // 16yqok7xkop.xls
        //console.log("url>>"+s3url+path+link.download)
        link.href = this.s3url + path + link.download;
        link.target = "_blank";
        link.click();
      }
    },
    childrenList() {
      //console.log(" children Len>>"+this.child_info.length)
      for (let i = 0; i < this.child_info.length; i++) {
        //console.log(" children>>"+this.child_info[i].grno)
        this.children.push(
          this.child_info[i].grno + ":" + this.child_info[i].name
        );
        this.selected_children =
          this.child_info[i].grno + ":" + this.child_info[i].name;
        this.displayAlbum();
      }
      //console.log(" children>>"+this.children)
    },
    displayAlbum() {
      //alert('11'+this.selected_children)
      let grno = this.selected_children;
      let res = grno.split(":");
      // return res[1];
      for (let i = 0; i < this.child_info.length; i++) {
        if (res[0] == this.child_info[i].grno)
          this.child_notice = this.child_info[i];
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.s3url = localStorage.getItem("awspath");
    const formData = {
      type: "Album",
    };
    axios
      .post("/parent/getNoticeHWAlbum", formData)
      .then((res) => {
        if (res.data.msg == "200") {
          if ((res.data.status = "SUCCESS")) {
            this.child_info = res.data.child_info;
            this.childrenList();
            if (this.child_notice.notices.length == 0) {
              this.showSnackbar("#b71c1c", "No Album Available...");
              return;
            }
          } else {
            alert(res.data.status_reason);
          }
        }
      })
      .catch((error) => {
        window.console.log(error);
      })
      .finally(() => {
        //close loader
        this.loader = false;
        //alert("done")
      });
  },
  computed: {
    searchByTitleOrDescription() {
      // if (this.child_notice) {
      //   return this.child_notice.notices.filter((tbdata) => {
      //     return (
      //       tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >=
      //         0 ||
      //       tbdata.description
      //         .toLowerCase()
      //         .indexOf(this.search.toLowerCase()) >= 0 ||
      //       tbdata.issue_date
      //         .toLowerCase()
      //         .indexOf(this.search.toLowerCase()) >= 0
      //     );
      //   });
      // }
      if (this.child_notice) {
        return this.child_notice.notices.filter((tbdata) => {
          return Object.keys(this.filters).every((f) => {
            return (
              (this.filters[f].length < 1 ||
                this.filters[f].includes(tbdata[f])) &&
              (tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
                tbdata.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0 ||
                tbdata.issue_date
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
            );
          });

          // return (
          //   tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >=
          //     0 ||
          //   tbdata.description
          //     .toLowerCase()
          //     .indexOf(this.search.toLowerCase()) >= 0 ||
          //   tbdata.issue_date
          //     .toLowerCase()
          //     .indexOf(this.search.toLowerCase()) >= 0
          // );
        });
      }
    },
  }, // end of computed()
};
</script>
